import {Injectable} from '@angular/core';
import {AuthenticationService, Usuario} from '@mapa/core';

@Injectable({
    providedIn: 'root'
})
export class SegurancaService {

    constructor(private auth: AuthenticationService) {
    }

    public getUsuarioLogado(): Usuario {
        return this.auth.getUsuarioLogado();
    }

    public isVisualizador(): boolean {
        return this.auth.hasPerfil('Visualizador');
    }

    public isEstabelecimento(): boolean {
        return this.auth.hasPerfil('Estabelecimento');
    }

    public isGestor(): boolean {
        return this.auth.hasPerfil('Gestor');
    }

    public isAnalistaFiscal(): boolean {
        return this.auth.hasPerfil('Analista');
    }

}
